import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";
import { GridRow, GridColumn, Img } from "arv-reactcomponents";

@inject("ProductStore", "CommonStore")
@observer
class ListingBanner extends Component {
  constructor(props) {
    super(props);
    this.getListingDetails = this.getListingDetails.bind(this);
    this.state = {
      image: null,
      title: null,
    };
  }

  componentWillMount() {
    const { isDesktop } = this.props.CommonStore;

    if (
      isDesktop &&
      this.props.ProductStore.collectionId &&
      this.props.ProductStore.type === "ProductListBanner"
    )
      this.getListingDetails();
  }

  getListingDetails() {
    const payload = { collections: [this.props.ProductStore.collectionId] };
    this.props.ProductStore.getListingDetails(payload).then(res => {
      this.setState({
        image:
          (res.bannerDetails &&
            res.bannerDetails.banner &&
            res.bannerDetails.banner.image &&
            res.bannerDetails.banner.image.path) ||
          null,
        title: (res.bannerDetails && res.bannerDetails.title) || null,
      });
    });
  }

  render() {
    if (!this.state.image) return null;
    return (
      <GridRow className="nw-listingbanner-wrapper">
        <GridColumn className="nw-listingbanner-col">
          <Img
            className="nw-listingbanner-img"
            src={this.state.image}
            alt={this.state.title}
          />
        </GridColumn>
      </GridRow>
    );
  }
}
ListingBanner.wrappedComponent.propTypes = {
  CommonStore: PropTypes.shape({
    isDesktop: PropTypes.bool.isRequired,
  }).isRequired,
  ProductStore: PropTypes.shape({
    getListingDetails: PropTypes.func.isRequired,
    isFetchingData: PropTypes.bool.isRequired,
    collectionId: PropTypes.string,
    type: PropTypes.string.isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("ProductStore", "CommonStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: ListingBanner.wrappedComponent,
  component: ListingBanner,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/ListingBanner/index.js